<template>
  <v-container fluid>
    <v-row>
      <v-col md="3" sm="12">
        <v-row>
          <v-col sm="12">
            <v-card id="workordercard">
              <v-img
                class="white--text align-end"
                height="200px"
                :src="tool.imagesource"
                contain
              >
              </v-img>
              <div class="d-flex justify-center py-2">
                <ToolStateChip :tool="tool" />
              </div>
              <v-card-title class="headline font-weight-bold mb-1">
                {{ tool.name }}
              </v-card-title>
              <v-card-subtitle>
                {{ tool.configuration }}
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col sm="12">
            <v-card id="workorderlist">
              <ToolProcessActiveList :toolid="tool.id" :detailed="true" />
              <v-divider />
              <ToolProcessInQueList :toolid="tool.id" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="9" sm="12">
        <ToolProcessInstructions :toolid="tool.id" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Tool from "../../models/Tool";
import ToolProcessActiveList from "../../components/Systems/ToolProcessActiveList";
import ToolProcessInQueList from "../../components/Systems/ToolProcessInQueList";
import ToolProcessInstructions from "../../components/Systems/ToolProcessInstructions";
import ToolStateChip from "../../components/Systems/ToolStateChip";
export default {
  name: "ToolProcessView",
  components: { ToolStateChip, ToolProcessInstructions, ToolProcessInQueList, ToolProcessActiveList },
  props: {
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    tool() {
      return Tool.query()
        .where("name", this.name)
        .with("state")
        .first();
    }
  }
};
</script>
